import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../../components/layout/Layout";

export default function EditWarehouse() {
    const [formData, setFormData] = useState({
        warehouseName: "",
        city: "",
        state: "",
        type: "drop",
        fullAddress: "",
        landMark: "",
        isDefault: true,
        pincodeId: "", // pincodeId will be updated as part of form submission
        locationCoordinates: [0, 0],
    });
    const [disableBtn, setDisableBtn] = useState(false);
    const [pincodes, setPincodes] = useState([]);

    const location = useLocation();
    const data = location.state.data;

    const navigate = useNavigate();

    console.log("Data", data)

    useEffect(() => {
        setFormData({
            warehouseName: data.wareHouseName,
            city: data.city,
            state: data.state,
            type: data.type,
            fullAddress: data.fullAddress,
            landMark: data.landMark,
            isDefault: data.isDefault,
            pincodeId: data?.pincodeId?._id || "",
            locationCoordinates: data?.location?.coordinates?.join(',') || "0,0",
        });

        const fetchPincodes = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/pincode/get-paginated-pincodes`);
                const pincode = response?.data?.result?.pincodes || [];
                setPincodes(pincode);
            } catch (error) {
                console.error("Error fetching pincodes:", error);
                toast.error("Failed to fetch pincodes.");
            }
        };

        fetchPincodes();
    }, [data]);

    const handleInputChange = (e) => {
        const name = e.target.name;
        let value = e.target.value;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setDisableBtn(true);
        try {
            const headers = {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
            };
            console.log("Edit warehouse", formData, "data", data);

            const formdata = new FormData();
            formdata.append("wareHouseName", formData.warehouseName);
            formdata.append("city", formData.city);
            formdata.append("state", formData.state);
            formdata.append("type", formData.type);
            formdata.append("fullAddress", formData.fullAddress);
            formdata.append("landMark", formData.landMark);
            formdata.append("isDefault", formData.isDefault);
            formdata.append("pincodeId", formData.pincodeId); // Send the selected pincodeId
            formdata.append("locationCoordinates", formData.locationCoordinates);

            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/warehouse/edit/${data._id}`,
                formdata,
                { headers }
            );

            if (response.data.statusCode === 200) {
                toast.success(response?.data?.message);
            } else {
                toast.error(response?.data?.message);
            }

            navigate(-1); // Go back to the previous page
        } catch (error) {
            console.error(error);
            toast.error("Failed to edit warehouse. Please try again.");
        }
        setDisableBtn(false);
    };

    return (
        <>
            <Layout>
                <ToastContainer />
                <div>
                    <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8 tracking-wide">
                        <div className="flex justify-between items-center">
                            <h2 className="text-xl font-medium">Update Warehouse</h2>

                            <button
                                onClick={() => navigate(-1)}
                                className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
                            >
                                Back
                            </button>

                        </div>
                        <div className="mt-10" onSubmit={handleSubmit}>
                            <form action="">
                                <div>
                                    <label htmlFor="" className="text-sm">
                                        Warehouse Name
                                    </label>{" "}
                                    <br />
                                    <input
                                        type="text"
                                        className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                                        placeholder="Enter Warehouse Name"
                                        name="warehouseName"
                                        value={formData.warehouseName}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="mt-6">
                                    <label htmlFor="" className="text-sm">
                                        City
                                    </label>{" "}
                                    <br />
                                    <input
                                        type="text"
                                        className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                                        placeholder="Enter City"
                                        name="city"
                                        value={formData.city}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="mt-6">
                                    <label htmlFor="" className="text-sm">
                                        State
                                    </label>{" "}
                                    <br />
                                    <input
                                        type="text"
                                        className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                                        placeholder="Enter State"
                                        name="state"
                                        value={formData.state}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="mt-6">
                                    <label htmlFor="" className="text-sm">
                                        Warehouse Type
                                    </label>{" "}
                                    <br />
                                    <select
                                        name="type"
                                        className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                                        value={formData.type}
                                        onChange={handleInputChange}
                                    >
                                        <option value="drop">Drop</option>
                                        <option value="store">Store</option>
                                    </select>
                                </div>
                                <div className="mt-6">
                                    <label htmlFor="" className="text-sm">
                                        Full Address
                                    </label>{" "}
                                    <br />
                                    <input
                                        type="text"
                                        className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm"
                                        placeholder="Enter Full Address"
                                        name="fullAddress"
                                        value={formData.fullAddress}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="mt-6">
                                    <label htmlFor="" className="text-sm">
                                        Landmark
                                    </label>{" "}
                                    <br />
                                    <input
                                        type="text"
                                        className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm"
                                        placeholder="Enter Landmark"
                                        name="landMark"
                                        value={formData.landMark}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="mt-6">
                                    <label htmlFor="" className="text-sm">
                                        Location Coordinates (Latitude, Longitude)
                                    </label>{" "}
                                    <br />
                                    <input
                                        type="text"
                                        className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm"
                                        placeholder="Enter Coordinates as Latitude, Longitude"
                                        name="locationCoordinates"
                                        value={formData.locationCoordinates}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="mt-6">
                                    <label htmlFor="" className="text-sm">
                                        Select Pincode
                                    </label>{" "}
                                    <br />
                                    <select
                                        name="pincodeId"
                                        className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                                        value={formData.pincodeId}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select Pincode</option>
                                        {pincodes.map((pincode) => (
                                            <option key={pincode._id} value={pincode._id}>
                                                {pincode.number} - {pincode.pinType}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="mt-6">
                                    <label htmlFor="" className="text-sm">
                                        Default Warehouse
                                    </label>{" "}
                                    <br />
                                    <input
                                        type="checkbox"
                                        name="isDefault"
                                        checked={formData.isDefault}
                                        onChange={(e) => setFormData({ ...formData, isDefault: e.target.checked })}
                                    />
                                </div>
                                <div className="mt-8 text-end">
                                    <button
                                        type="submit"
                                        className="bg-[#2c2c38] text-white h-[40px] px-8 rounded-md text-sm hover:bg-[#191919]"
                                        disabled={disableBtn}
                                    >
                                        <i className="fa fa-plus"></i>{" "}
                                        {disableBtn ? "Updating ..." : "Update Warehouse"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
}
